<template>
	<!--<div class="tarmac-dev" v-show="(hostname == 'localhost')">TEST</div>-->
	<img class="logoimage" src="/tarmac-drawing.svg" />
</template>
<style>
	.tarmac-dev {


	 }
</style>
<script>

export default {
data() {
    return {
      hostname: 'localhost'
    }
  },
}
</script>